var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"versions"},[_c('HeaderReturn',{attrs:{"title":"版本"}}),_c('div',{staticClass:"versions_ul"},[_c('div',[_c('img',{attrs:{"src":require("../../assets/img/page/kf.png")}}),_c('p',{staticStyle:{"margin-top":"10px","font-size":"18px"}},[_vm._v("TY "+_vm._s(_vm.DataList.valStr))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }